import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  INotification,
  NOTIFICATION_STATUS,
} from "../../../models/notification.model";
import { NotificationService } from "../../../services/notification/notification.service";
import { getADTCodeLabel } from "../../../mock/notification.mock";
import { MessageService } from "primeng/api";
import { formatExactDate } from "../../../util/common.util";
import { TEXTS } from "../../../constants/common.constants";
import { NotificationSharedService } from "../../notifications-shared.service";
import { Subscription } from "rxjs";

@Component({
  selector: "mxn-notification-list",
  templateUrl: "./notification-list.component.html",
  styleUrl: "./notification-list.component.scss",
})
export class NotificationListComponent {
  formatExactDate(arg0: string): string {
    return formatExactDate(arg0);
  }
  constructor(
    private readonly notificationService: NotificationService,
    private readonly messageService: MessageService,
    private readonly notificationSharedService: NotificationSharedService
  ) {}
  @Input() notificationCountByStatus: any = {};
  @Input() notifications: INotification[] = [];
  @Input() loading: boolean = true;
  @Input() totalNotifications: number = 0;
  @Input() selectedNotifications: string[] = [];
  @Input() currentPageSettings = {};
  @Input() notificationsinList = 0;
  @Input() selectAllNotificationsForMultiSelect: boolean = false;

  numberOfPanelsToDisplayDirectly = 2;
  @Input() selectedNotification: any;
  selectedNotificationPanelDetails: any;
  activeIndex: number | null = null;
  removeNotificationModal: boolean = false;
  notificationIdInFocus: string = "";
  notificationIdInFocusIndex: number = -1;

  @Output() onNotificationSelect: EventEmitter<INotification> =
    new EventEmitter<INotification>();
  @Output() getNotificationCall: EventEmitter<INotification> =
    new EventEmitter<INotification>();
  @Output() scrollToComments: EventEmitter<void> = new EventEmitter<void>();
  @Output() updateOpenedNotification: EventEmitter<INotification> =
    new EventEmitter<INotification>();
  @Output() handleSelectedNotifications: EventEmitter<{
    selectedNotifications: string[];
    selectAllNotificationsForMultiSelect: boolean;
  }> = new EventEmitter<{
    selectedNotifications: string[];
    selectAllNotificationsForMultiSelect: boolean;
  }>();
  @Output() notificationRemovedUpdateStats: EventEmitter<any> =
    new EventEmitter<any>();
  remove = TEXTS.removeText;
  markAsRead = TEXTS.markAsReadText;
  markAsUnread = TEXTS.markAsUnreadText;
  notStarted = TEXTS.notStartedText;
  inProgress = TEXTS.inProgressText;
  completed = TEXTS.completedText;
  alert = TEXTS.alertText;
  removeModalText = TEXTS.selectSingleNotificationRemoveModalText;
  private selectAllFlagSubscription: Subscription | undefined;

  ngOnInit() {
    this.selectAllFlagSubscription =
      this.notificationSharedService.selectAllFlagTriggerAction$.subscribe(
        (selectAllFlag) => {
          this.selectAllNotificationsForMultiSelect = selectAllFlag;
        }
      );
    this.setActiveTabIndex();
  }

  setActiveTabIndex() {
    const index = this.notifications.findIndex(
      (notification) => notification.id === this.selectedNotification?.id
    );
    this.activeIndex = index !== -1 ? index : null;
  }

  onNotificationListOpenClose(event: any) {
    this.selectedNotifications = [];
    this.selectAllNotificationsForMultiSelect = false;
    this.notificationSharedService.setDefaultValuesMultiSelect({
      selectedNotifications: this.selectedNotifications,
      selectAllNotificationsForMultiSelectFlag:
        this.selectAllNotificationsForMultiSelect,
    });
  }

  onNotificationClick(id: any) {
    this.selectedNotification = this.notifications?.find(
      (notification) => notification.id === id
    );
    this.selectAllNotificationsForMultiSelect = false;
    this.selectedNotifications = [];
    this.notifications = this.notifications.map((notification) => {
      if (notification.id === id) {
        notification.notification_reads =
          notification.notification_reads?.length > 0
            ? notification.notification_reads
            : [{ read_at: "", created_at: "", updated_at: "", id: "" }];
      }
      return notification;
    });
    this.selectedNotificationPanelDetails =
      this.getPanelNames(this.selectedNotification)
        .slice(0, this.numberOfPanelsToDisplayDirectly)
        .map((panel: any) => panel.name)
        .join(", ") || "-";

    this.onNotificationSelect.emit(this.selectedNotification);
  }
  updateNotificationStatusCall(
    notificationId: string,
    status: string,
    previousStatus: string
  ) {
    this.notificationService
      .updateNotificationStatus(notificationId, {
        newStatus: status,
        currentStatus: previousStatus,
      })
      .subscribe({
        next: (res) => {
          this.notifications = this.notifications.map((notification) => {
            if (notification.id === notificationId) {
              notification.status = status;
            }
            return notification;
          });
          this.updateOpenedNotification.emit({
            ...this.selectedNotification,
            id: notificationId,
            previousStatus,
            status,
          });
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Status updated successfully",
          });
        },
        error: (err) => {},
      });
  }
  getPanelNames(notification: INotification) {
    return notification.notificationsPanels?.map((item) => {
      return {
        name: item.panel?.display_name || item.panel?.panel_name,
        patient_identifier: item.patient_identifier,
      };
    });
  }
  getCardStyleClasses = (status: string) => {
    switch (status) {
      case NOTIFICATION_STATUS.COMPLETED:
        return "acc-tab-completed";
      case NOTIFICATION_STATUS.IN_PROGRESS:
        return "acc-tab-inprogress";
      case NOTIFICATION_STATUS.NOT_STARTED:
      default:
        return "acc-tab-notstarted";
    }
  };
  scrollToCommentsHandler() {
    this.scrollToComments.emit();
  }
  getADTLabel(code: string) {
    if (code?.toLowerCase() == "covid") {
      return "COVID POSITIVE";
    }
    console.log('Deployment Demo');
    const label = getADTCodeLabel(code);
    if (label === code) {
      return label;
    }
    return label + " (" + code + ")";
  }

  makeNotificationReadUnread(notificationId: string, markAsRead: boolean) {
    this.notificationService
      .updateNotificationReadUnread(notificationId, markAsRead)
      .subscribe({
        next: (res) => {
          this.notifications = this.notifications.map((notification) => {
            if (notification.id === notificationId) {
              notification.notification_reads = markAsRead
                ? [{ read_at: "", created_at: "", updated_at: "", id: "" }]
                : [];
            }
            return notification;
          });
        },
        error: (err) => {},
      });
  }

  handleMultiSelectNotifications(notificationId: any) {
    this.activeIndex = -1;

    if (this.selectAllNotificationsForMultiSelect) {
      this.selectedNotifications = [notificationId];
      this.selectAllNotificationsForMultiSelect = false;
    }

    this.handleSelectedNotifications.emit({
      selectedNotifications: this.selectedNotifications,
      selectAllNotificationsForMultiSelect:
        this.selectAllNotificationsForMultiSelect,
    });
  }

  removeNotification(notificationId: string, notificationIndex: number) {
    this.notificationIdInFocus = notificationId;
    this.removeNotificationModal = true;
    this.notificationIdInFocusIndex = notificationIndex;
  }

  onRemoveNotificationConfirm() {
    this.notificationService
      .removeNotificationFromUserView(this.notificationIdInFocus)
      .subscribe({
        next: (res) => {
          if (this.notifications) {
            this.notifications = this.notifications.filter((notification) => {
              if (this.notificationIdInFocus != notification.id) {
                return true;
              }
              this.notificationCountByStatus["all"] =
                this.notificationCountByStatus?.["all"] - 1;
              this.notificationCountByStatus[notification.status] =
                this.notificationCountByStatus?.[notification.status] - 1;

              return false;
            });
          }

          let defaultPage = false;

          if (this.selectedNotifications?.length > 0) {
            this.selectedNotifications = this.selectedNotifications?.filter(
              (selectedNotification) => {
                return selectedNotification != this.notificationIdInFocus;
              }
            );
          }

          if (this.activeIndex != -1) {
            if (this.activeIndex == 0) {
              if (this.activeIndex == this.notificationIdInFocusIndex) {
                this.activeIndex = -1;
                defaultPage = true;
              }
            } else {
              if (
                this.activeIndex &&
                this.activeIndex != this.notificationIdInFocusIndex
              ) {
                if (this.activeIndex > this.notificationIdInFocusIndex) {
                  if (this.activeIndex > 0) {
                    this.activeIndex = this.activeIndex - 1;
                  }
                }
              } else {
                this.activeIndex = -1;
                defaultPage = true;
              }
            }
          } else {
            defaultPage = true;
          }

          this.notificationSharedService.setDefaultValuesMultiSelect({
            selectedNotifications: this.selectedNotifications,
            selectAllNotificationsForMultiSelectFlag: false,
            setDefaultPage: defaultPage,
          });

          this.messageService.add({
            severity: "success",
            summary: "Operation Successful",
            detail: "Notification has been removed successfully.",
          });
          this.notificationRemovedUpdateStats.emit({
            totalNotifications: this.totalNotifications - 1,
            notificationsinList: this.notificationsinList - 1,
          });
        },
        error: (err) => {},
      });
  }

  checkIfMultiSelectNotificationsEnabled(event: any, notificationId: string) {
    this.activeIndex = -1;
    const selectedSet = new Set(this.selectedNotifications);

    if (this.selectAllNotificationsForMultiSelect) {
      this.selectedNotifications = [notificationId];
      this.selectAllNotificationsForMultiSelect = false;
    } else {
      if (selectedSet.has(notificationId)) {
        selectedSet.delete(notificationId);
      } else {
        selectedSet.add(notificationId);
      }

      this.selectedNotifications = Array.from(selectedSet);
    }

    this.handleSelectedNotifications.emit({
      selectedNotifications: this.selectedNotifications,
      selectAllNotificationsForMultiSelect:
        this.selectAllNotificationsForMultiSelect,
    });

    event.stopPropagation();
  }

  resetNotificationListInteractivity() {
    this.activeIndex = -1;
  }

  handleCheckboxKeyDown(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.selectAllFlagSubscription?.unsubscribe();
  }
}
